import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BookOpen } from "lucide-react";

export const TemplatesDialog = ({ open, onClose }) => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    if (open) api.get("/campaign-templates").then(({ data }) => setTemplates(data)).catch(() => {});
  }, [open]);

  const use = async (t) => {
    setBusy(t.id);
    try {
      const { data } = await api.post(`/campaign-templates/${t.id}/use`);
      toast.success(`Campagne « ${t.nom} » créée en brouillon — personnalisez la zone puis validez`);
      onClose();
      navigate(`/campagnes/${data.id}`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-y-auto" data-testid="templates-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><BookOpen size={18} className="text-accent" /> Bibliothèque métiers</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">Modèles de campagnes prêts à l'emploi : ciblage, codes NAF, décideurs et signaux pré-remplis. Il vous restera à préciser la zone géographique.</p>
        <div className="grid gap-2 sm:grid-cols-2" data-testid="templates-list">
          {templates.map((t) => (
            <div key={t.id} className="rounded-md border p-3">
              <p className="font-display font-semibold">{t.metier}</p>
              <p className="mt-0.5 line-clamp-2 text-xs text-muted-foreground">{t.service_vendu}</p>
              <p className="mt-1 line-clamp-1 text-xs text-muted-foreground">Cibles : {t.secteurs.slice(0, 3).join(", ")}</p>
              <Button size="sm" className="mt-2 w-full" onClick={() => use(t)} disabled={busy === t.id} data-testid={`use-template-${t.id}`}>
                {busy === t.id ? "Création…" : "Utiliser ce modèle"}
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const downloadExport = async (path, filename) => {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Export Excel téléchargé");
  } catch {
    toast.error("Export impossible");
  }
};
